export default __webpack_public_path__ + "static/media/DinosaursCarnivores_05.82976ac4.png";